import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider) {
	$stateProvider.state('admin', {
		abstract: true,
		parent: 'app'
	});
}

app.config(stateConfig);
